import { mapActions, MapName } from '../reducers/maps/actions'
import { useAppDispatch } from './redux'

type KeysOfUnion<T> = T extends T ? keyof T : never

/**
 * @example
 *   const dispatchMap = useMapDispatch()
 *   dispatchMap('mapName', 'setMapFilters', filters)
 */
export function useMapDispatch() {
    const dispatch = useAppDispatch()

    return <
        M extends MapName,
        K extends KeysOfUnion<typeof mapActions[M]>
    >(
        mapName: M,
        actionKey: K,
        ...args: any
    ) => {
        const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as M
        const creator = mapActions[lowerFirstMapName][actionKey] as (...a: any[]) => any
        if (creator) dispatch(creator(...args));
    }
}
